import { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import ArticleIcon from '@mui/icons-material/Article';
import WebIcon from '@mui/icons-material/Web';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import GavelIcon from '@mui/icons-material/Gavel';
import Articles from '../Articles/Articles.jsx';
import Pages from '../Pages/Pages.jsx';
import Subscribers from '../Subscribers/Subscribers.jsx';
import Legal from '../Legal/Legal.jsx';

// The top-level sections. The old layout hard-coded 100px gutters and a
// `calc(100% - 200px)` centre column, which left a phone with almost no usable
// width; the content now spans the viewport and is only bounded on wide screens.
function Home() {
    const [selectedTab, setSelectedTab] = useState(0);

    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
                <Tabs
                    value={selectedTab}
                    onChange={(_, value) => setSelectedTab(value)}
                    variant='scrollable'
                    scrollButtons={false}
                    sx={{ px: { xs: 1, md: 3 }, maxWidth: 1280, mx: 'auto' }}
                >
                    <Tab icon={<ArticleIcon />} iconPosition='start' label='Conteúdos' />
                    <Tab icon={<WebIcon />} iconPosition='start' label='Páginas' />
                    <Tab icon={<MailOutlineIcon />} iconPosition='start' label='Subscritores' />
                    <Tab icon={<GavelIcon />} iconPosition='start' label='Termos e Políticas' />
                </Tabs>
            </Box>

            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    width: '100%',
                    maxWidth: 1280,
                    mx: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {selectedTab === 0 && <Articles />}
                {selectedTab === 1 && <Pages />}
                {selectedTab === 2 && <Subscribers />}
                {selectedTab === 3 && <Legal />}
            </Box>
        </Box>
    );
}

export default Home;
